import React, { MouseEventHandler, ReactNode } from 'react';

import { ThemeProvider } from 'styled-components';

import Box from '../../Box/Box';
import Dropdown from '../../Dropdown/Dropdown';
import Bubble from '../../Bubble/Bubble';
import { DetailSidebarItem, DetailSidebarItemButton } from '../styles';

type BubbleType =
  | 'blue'
  | 'blue-dark'
  | 'yellow'
  | 'white'
  | 'gray'
  | 'gray-light'
  | 'orange'
  | 'green'
  | 'red'
  | 'purple'
  | 'staff';

export type Label = {
  text: string;
  bubbleText?: string;
  bubbleType?: BubbleType;
  dropdownItems?: ReactNode;
};

export interface SidebarItem {
  label: Label;
  content: ReactNode;
}

export interface ModalDetailSidebarItemProps {
  label: Label;
  onClick?: MouseEventHandler;
  isActive?: boolean;
}

function ModalDetailSidebarItem(props: ModalDetailSidebarItemProps) {
  const { label, onClick, isActive, ...otherProps } = props;

  function renderBubble() {
    return label.bubbleText && label.bubbleType && <Bubble type={label.bubbleType}>{label.bubbleText}</Bubble>;
  }

  function renderChildren() {
    const withDropdown = (
      <Dropdown
        trigger={({ onClick }) => (
          <Dropdown.Trigger type="aura" onClick={onClick}>
            {label.text}
          </Dropdown.Trigger>
        )}
      >
        {label.dropdownItems}
      </Dropdown>
    );

    const withoutDropdown = <>{label.text}</>;

    return (
      <Box justifyContent="space-between" gridGap="medium">
        {label.dropdownItems ? withDropdown : withoutDropdown}
        {renderBubble()}
      </Box>
    );
  }

  if (label.dropdownItems) {
    return (
      <li>
        <DetailSidebarItem>{renderChildren()}</DetailSidebarItem>
      </li>
    );
  }
  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        modalDetailSidebarItemActive: isActive && !label.dropdownItems,
      })}
    >
      <li>
        <DetailSidebarItemButton type="button" onClick={onClick} {...otherProps}>
          {renderChildren()}
        </DetailSidebarItemButton>
      </li>
    </ThemeProvider>
  );
}

ModalDetailSidebarItem.defaultProps = {
  onClick: (_event: MouseEvent) => {},
  isActive: false,
};

export default ModalDetailSidebarItem;
